// eslint-disable-next-line no-unused-vars
import $ from 'jquery';

(function () {
    window.InitAuth = new function () {
        this.exist = function (t) {
            $.ajax({
                method: 'POST',
                url: route('auth.exist'),
                data:$('#exist-form-modal').serialize(),
                success: (res) => {
                    $('#quick-login-wrapper').html(res);
                },
                error: (xhr) => {
                    $(t).removeClass('btn-loading');
                    this.printErrorMsg(xhr.responseJSON.errors);
                },
            });
        };

        this.loggedIn = function () {
            $.ajax({
                method: 'POST',
                url: route('login.post'),
                data:$('#login-form-modal').serialize(),
                success: (res) => {
                    window.location.reload();
                },
                error: (xhr) => {
                    this.printErrorMsg(xhr.responseJSON.errors);
                },
            });
        };

        this.register = function () {
            $.ajax({
                method: 'POST',
                url: route('register.post'),
                data:$('#register-form-modal').serialize(),
                success: (res) => {
                    window.location.reload();
                },
                error: (xhr) => {
                    this.printErrorMsg(xhr.responseJSON.errors);
                },
            });
        };

        this.back = function () {

            $.ajax({
                method: 'POST',
                url: route('auth.back_exist'),
                data:$('.auth-form').serialize(),
                success: (res) => {
                    $('#quick-login-wrapper').html(res);
                },
            });
        };

        this.authField = function (value = 'email') {
            $('input[name="auth_field"]').val(value);
        };

        this.togglePassword = function (t) {
            const password = $(t).siblings('.toggle-password');

            if (password.attr('type') === 'password') {
                password.attr('type','text');
            } else {
                password.attr('type','password');
            }
        };

        this.printErrorMsg = function (msg) {
            $('.error-message').html('');
            $.each(msg, function (key, value) {
                $('#' + key + '-error-message').html(value[0]);
            });
        };
    }();
})();
